import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ITTraining from './pages/ITTraining';
import ProgrammingCourses from './pages/it-training/ProgrammingCourses';
import NonProgrammingCourses from './pages/it-training/NonProgrammingCourses';
import SpecialTraining from './pages/it-training/SpecialTraining';
import ITBlog from './pages/it-training/ITBlog';
import ITContact from './pages/it-training/ITContact';
import CourseDetail from './pages/it-training/CourseDetail';
import AiChatWidget from './components/AiChatWidget';

function App() {
  return (
    <BrowserRouter>
      <>
        <Routes>
          <Route path="/"                    element={<ITTraining />} />
          <Route path="/programming"         element={<ProgrammingCourses />} />
          <Route path="/non-programming"     element={<NonProgrammingCourses />} />
          <Route path="/special"             element={<SpecialTraining />} />
          <Route path="/blog"                element={<ITBlog />} />
          <Route path="/contact"             element={<ITContact />} />
          <Route path="/course/:slug"        element={<CourseDetail />} />
        </Routes>
        <AiChatWidget />
      </>
    </BrowserRouter>
  );
}

export default App;
